var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Edit")]),_c('b-row',[_c('b-col',[_c('SelectMunicipio',{model:{value:(_vm.address.city_id),callback:function ($$v) {_vm.$set(_vm.address, "city_id", $$v)},expression:"address.city_id"}})],1)],1),_c('pre',[_vm._v(_vm._s(_vm.address))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }